import Cookies from "js-cookie";

// 本地存储用户登录相关

export function getToken () {
    return Cookies.get("userToken");
}

export function setToken (token) {
    Cookies.set("userToken", token, { expires: 1 });
}

export function getMaterialToken () {
  return Cookies.get("Token");
}

export function setMaterialToken (_Token) {
  Cookies.set("Token", _Token, { expires: 1 });
}

export function setUserId (id) {
    Cookies.set("userId", id, { expires: 1 });
}

export function getUserId () {
    return Cookies.get("userId");
}

export function setUserName (name) {
    localStorage.setItem("userName", name);
}

export function getUserName () {
    return localStorage.getItem("userName");
}

export function setModelId (id) {
    localStorage.setItem("modelId", id);
}
export function getModelId () {
    return localStorage.getItem("modelId");
}

export function setUserAvatar (url) {
  localStorage.setItem("avatar", url);
}

export function getUserAvatar () {
  return localStorage.getItem("avatar");
}

export function removeUserInfo () {
    Cookies.remove("userToken");
    Cookies.remove("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userFunction");
    localStorage.removeItem("avatar");
}

// 用户可用功能
export function setUserFunction (userFunction) {
    localStorage.setItem("userFunction", userFunction);
}

export function getUserFunction () {
    return localStorage.getItem("userFunction");
}



// WEBPACK FOOTER //
// ./src/utils/auth.js